import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
import { onMounted, onBeforeUnmount, computed, watch, ref, nextTick, } from 'vue';
import { useRoute, useRouter, } from 'vue-router';
import { pageSizeOptionList } from '@/constants';
import { isValidDate, isValidValueByOptionList, } from '@/utils';
import SubController from '@V/WorkerMonthlyAttendance/SubController.vue';
import WorkerMonthlyAttendanceTable from '@V/WorkerMonthlyAttendance/WorkerMonthlyAttendanceTable.vue';
import { workerMonthlyAttendanceUseYnTypeOptionList } from '@/constants/workerMonthlyAttendance/workerMonthlyAttendanceUseYnTypeOptionList';
import { workerMonthlyAttendanceSearchTypeOptionList } from '@/constants/workerMonthlyAttendance/workerMonthlyAttendanceSearchTypeOptionList';
import vuexStore from '@/vuex-store';
import dateFormatType from '@/constants/dateFormatType';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // 라이더 출근표 페이지
        const route = useRoute();
        const router = useRouter();
        const isInitialized = ref(false);
        const isFetching = ref(true);
        const isError = ref(false);
        const getWorkerMonthlyAttendanceList = async () => {
            vuexStore.dispatch('workerMonthlyAttendance/resetWorkerMonthlyAttendanceList');
            isFetching.value = true;
            isError.value = false;
            try {
                await vuexStore.dispatch('workerMonthlyAttendance/getWorkerMonthlyAttendanceList');
            }
            catch {
                isError.value = true;
            }
            finally {
                isFetching.value = false;
            }
        };
        const filterOption = computed(() => vuexStore.state.workerMonthlyAttendance.filterOption);
        const pageSize = computed(() => vuexStore.state.workerMonthlyAttendance.pageSize);
        const pageNumber = computed(() => vuexStore.state.workerMonthlyAttendance.pageNumber);
        const sortOption = computed(() => vuexStore.state.workerMonthlyAttendance.sortOption);
        /**
         * 필터 변경 시 라이더 출근표 목록 조회
         */
        watch(() => ({
            ...filterOption.value,
            pageSize,
            sortOption,
        }), async (value) => {
            if (!isInitialized.value) {
                return;
            }
            const { yearMonth, fromTimePeriod, toTimePeriod, workerUseYn, searchType, searchKey, } = value;
            // 변경된 값 router 동기화
            nextTick(() => router.replace({
                query: {
                    yearMonth,
                    fromTimePeriod,
                    toTimePeriod,
                    workerUseYn,
                    searchType,
                    searchKey,
                    pageSize: value.pageSize.value,
                },
            }).catch(() => { }));
            // 필터 변경시 1 페이지가 아니면 페이지 초기화
            const firstPage = 1;
            if (pageNumber.value !== firstPage) {
                vuexStore.dispatch('workerMonthlyAttendance/setPageNumber', firstPage);
                return;
            }
            await getWorkerMonthlyAttendanceList();
        }, {
            deep: true,
        });
        /**
         * 페이지 변경 시 라이더 출근표 목록 조회
         */
        watch(() => pageNumber.value, async () => {
            await getWorkerMonthlyAttendanceList();
        });
        /**
         * 시간이 올바른 형태인지 확인
         */
        const isValidTime = (time) => {
            const isInt = Number(time) % 1 === 0;
            const startTime = 0;
            const endTime = 23;
            const isInBound = Number(time) >= startTime && Number(time) <= endTime;
            return isInt && isInBound;
        };
        const getValidQuery = (query) => {
            const { yearMonth: yearMonthQuery, fromTimePeriod: fromTimePeriodQuery, toTimePeriod: toTimePeriodQuery, workerUseYn: workerUseYnQuery, searchType: searchTypeQuery, searchKey: searchKeyQuery, } = query;
            const dateFormat = dateFormatType.MONTH;
            return {
                yearMonth: isValidDate(yearMonthQuery, dateFormat)
                    ? yearMonthQuery
                    : filterOption.value.yearMonth,
                fromTimePeriod: isValidTime(fromTimePeriodQuery)
                    ? fromTimePeriodQuery
                    : filterOption.value.fromTimePeriod,
                toTimePeriod: isValidTime(toTimePeriodQuery)
                    ? toTimePeriodQuery
                    : filterOption.value.toTimePeriod,
                searchType: isValidValueByOptionList(searchTypeQuery, workerMonthlyAttendanceSearchTypeOptionList)
                    ? searchTypeQuery
                    : filterOption.value.searchType,
                searchKey: searchKeyQuery,
                workerUseYn: isValidValueByOptionList(workerUseYnQuery, workerMonthlyAttendanceUseYnTypeOptionList)
                    ? workerUseYnQuery
                    : filterOption.value.workerUseYn,
            };
        };
        const initPage = async () => {
            const validQuery = getValidQuery(route.query);
            vuexStore.dispatch('workerMonthlyAttendance/setFilterOption', validQuery);
            const newPageSize = isValidValueByOptionList(route.query.pageSize, pageSizeOptionList)
                ? route.query.pageSize
                : pageSize.value;
            await vuexStore.dispatch('workerMonthlyAttendance/setPageSize', newPageSize);
            nextTick(() => router.replace({
                query: {
                    ...validQuery,
                    pageSize: newPageSize,
                },
            }).catch(() => { }));
            isInitialized.value = true;
        };
        /**
         * 페이지 진입 시 라이더 출근표 목록 조회
         */
        onMounted(async () => {
            await initPage();
            await getWorkerMonthlyAttendanceList();
        });
        const getterSubscribeHubId = computed(() => vuexStore.getters['hubSelector/getterSubscribeHubId']);
        /**
         * 선택 허브 변경시 초기화
         */
        watch(() => getterSubscribeHubId.value, async (value) => {
            if (!value) {
                return;
            }
            vuexStore.dispatch('workerMonthlyAttendance/resetStore');
            await initPage();
        });
        /**
         * 페이지 이탈 시 초기화
         */
        onBeforeUnmount(() => {
            vuexStore.dispatch('workerMonthlyAttendance/resetStore');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SubController),
                _createVNode(WorkerMonthlyAttendanceTable, {
                    "is-error": isError.value,
                    "is-fetching": isFetching.value
                }, null, 8 /* PROPS */, ["is-error", "is-fetching"])
            ]));
        };
    }
});
